import React from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Modal } from '@oforce/global-components';

import { GraphQLErrors } from '../../../components';

import { VehicleStakeholderFormFields } from '.';
import { useVehicleStakeholderFormOptions } from '../hooks';
import { vehicleStakeholderInitialValues, vehicleStakeholderValidationFields } from '../model/step';
import useAddVehicleStakeholder from '../hooks/useAddVehicleStakeholder';

export default function AddVehicleStakeholder({ vehicle, isOpen, toggle }) {
  const { add, reset, loading, error } = useAddVehicleStakeholder({ vehicle, onCompleted: toggle });
  const formOptions = useVehicleStakeholderFormOptions();
  const validationSchema = yup.object().shape(vehicleStakeholderValidationFields);
  const initialValues = vehicleStakeholderInitialValues({}, formOptions);

  return (
    <Formik validationSchema={validationSchema} initialValues={initialValues} enableReinitialize onSubmit={add}>
      {formik => (
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          onOpened={() => {
            reset();
            formik.handleReset();
          }}
          title="Add Vehicle Stakeholder"
          loading={loading}
          submitButtonText="Add Vehicle Stakeholder"
          submitButtonProps={{ loadingText: 'Adding...' }}
          submitButtonDisabled={formik.isSubmitting}
          onSubmit={formik.handleSubmit}
        >
          <GraphQLErrors error={error} />
          <VehicleStakeholderFormFields formOptions={formOptions} />
        </Modal>
      )}
    </Formik>
  );
}
